import { Box } from '@mui/system'
import { FC } from 'react'
import { Loader } from '../../UI/Loaders/Loader'
import { LoaderType } from '../../UI/Loaders/Loader/types'
import { LoaderWrapperProps } from './types'

export const LoaderWrapper: FC<LoaderWrapperProps> = ({
  loading,
  children,
  top //если с лоэдером контент прыгает
}) => {
  return (
    <Box
      sx={
        loading ? { position: 'relative', top: top ? `-${top}px` : '0px' } : {}
      }
    >
      {loading && <Loader type={LoaderType.ABSOLUTE} />}
      <Box
        sx={
          loading
            ? {
                opacity: '0.5',
                pointerEvents: 'none'
              }
            : {}
        }
      >
        {children}
      </Box>
    </Box>
  )
}
